import "./myActivity.css";
import { useEffect, useState } from "react";
import { Check } from "lucide-react";

import { useAuth } from "../../../context/AuthContext";
import { getRecentActivity, timeAgo } from "../../../services/dashboardService";

export default function MyActivity() {
  const { globalUser } = useAuth();

  const [activities, setActivities] = useState([]);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (!globalUser?.uid) return;

    const loadActivity = async () => {
      const data = await getRecentActivity(globalUser.uid);
      setActivities(data);
    };

    loadActivity();
  }, [globalUser]);

  const visibleActivities = showAll ? activities : activities.slice(0, 3);

  return (
    <div className="dashboard-panel">

      <div className="panel-header">
        <div className="panel-title">
          <span>My Activity</span>
        </div>

        {activities.length > 3 && (
          <button
            className="panel-link"
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show less" : "View all"}
          </button>
        )}
      </div>

      {activities.length === 0 ? (
        <div className="no-hearings">
          No recent activity
        </div>
      ) : (
        <div className="activity-list">

          {visibleActivities.map((activity) => (

            <div className="activity-item" key={activity.id}>

              <div className="activity-icon">
                <Check size={13} strokeWidth={3} />
              </div>

              <div className="activity-content">

                <h4>{activity.title}</h4>

                <p>{activity.subtitle}</p>

              </div>

              <span className="activity-time">
                {timeAgo(activity.date)}
              </span>

            </div>

          ))}

        </div>
      )}

    </div>
  );
}
